import { styled } from '../../../../../../core/theme/styled';
import { Caption } from '../../../../../atoms/Text/Text';

export const UnderlineWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${(props) => props.theme.configuration.strokeColor};
  padding: 1.5rem 0;
`;

export const StyledText = styled(Caption)`
  flex: 1;
  &:first-letter {
    text-transform: capitalize;
  }
`;

export const StyledHeader = styled.div`
  line-height: 1.4;
  font-size: ${(props) => props.theme.sizes.normal};
  margin-bottom: ${(props) => props.theme.sizes.xxxsmall};
`;

export const StyledLogo = styled.img`
  width: ${(props) => props.theme.sizes.xlarge};
`;
